import { render, staticRenderFns } from "./questionTitleList.vue?vue&type=template&id=9563e9ea&scoped=true"
import script from "./questionTitleList.vue?vue&type=script&lang=js"
export * from "./questionTitleList.vue?vue&type=script&lang=js"
import style0 from "./questionTitleList.vue?vue&type=style&index=0&id=9563e9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9563e9ea",
  null
  
)

export default component.exports